import React from 'react';
import './Contacts.css';

function Contacts() {
  return (
    <div className="Contacts">
      <h1>Contacts</h1>
    </div>
  );
}

export default Contacts;
